// extracted by mini-css-extract-plugin
export default {"tooltipWrapper":"Validate_tooltipWrapper__rFMOl"};